// Copyright © 2006-2020 Lexbe Inc. All rights reserved.

// These are the options we are using for Horizontal and Vertical Bar Charts.
// Other options are available and can be added here and in the components.
// More Details:  https://swimlane.gitbook.io/ngx-charts/examples/bar-charts/vertical-bar-chart

export class BarChartOptions {
  // The dimensions of the chart [width, height]. If left undefined, the chart will fit to the parent container size.
  view: number[];
  // The color scheme of the chart.
  scheme: string = "ocean";
  // The color scale type. Can be either 'ordinal' or 'linear'
  schemeType: string = "ordinal";
  // Show or hide the legend.
  legend: boolean = false;
  // The legend title.
  legendTitle: string;
  // The legend position. Can be either 'right' or 'below'
  legendPosition: string = "right";
  // Show or hide the x axis.
  xAxis: boolean = true;
  // Show or hide the y axis.
  yAxis: boolean = true;
  // Show or hide the grid lines.
  showGridLines: boolean = false;
  // Show or hide the x axis label.
  showXAxisLabel: boolean = true;
  // Show or hide the y axis label.
  showYAxisLabel: boolean = true;
  // The x axis label text.
  xAxisLabel: string;
  // The y axis label text.
  yAxisLabel: string;
  // Round edges for the bars.
  roundEdges: boolean = false;
}
